import React, {useState} from "react";
import Button from "../Elements/Button";
import {addToWishlist, removeFromWishlist} from "../Functions/Wishlist";
import {ButtonStyles} from "./consts";
import {FONTELLO_FONTAWESOME_HEART} from "../SVG/consts";
import {WooUserContext} from "../WooUserContext";
import LoadSpinner from "../Elements/LoadSpinner";
import SvgLink from '../SVG';

function WishlistButton({databaseId}) {
    const [addedToWishlist, setAddedToWishlist] = useState();
    const {wishlistState, userData} = React.useContext(WooUserContext);
    const [wishlist ,setWishlist] = wishlistState;
    const productInWishlist = (databaseId, wishlist) => {
        if (!wishlist || !databaseId) return false;
        return wishlist.filter(item => Number(item) === databaseId).length > 0
    };
    return (
        <>
            {addedToWishlist && addedToWishlist.error && <small className="error">Error {addedToWishlist.added ? 'removing from' : 'adding to'} wishlist</small>}
            <Button className={productInWishlist(databaseId, wishlist) && 'added'} style={ButtonStyles.icon} onClick={(e) => {
                if (!userData.data || userData.data.viewer == null) {
                    e.preventDefault();
                    return false;
                }
                productInWishlist(databaseId, wishlist) ? removeFromWishlist(e, databaseId, setAddedToWishlist, setWishlist) : addToWishlist(e, databaseId, setAddedToWishlist, setWishlist)
            }}>
                {addedToWishlist && addedToWishlist.loading ? <LoadSpinner/> : <SvgLink {...FONTELLO_FONTAWESOME_HEART} />}
                {(!userData.data || userData.data.viewer == null) && <span className="button-tooltip">Sign-up to add to wishlist</span>}
            </Button>
        </>
    )
}

export default WishlistButton;